export default __webpack_public_path__ + "static/media/a020-ngo-2.486d5c82.svg";